// RegisterDeliverable.js

import React, { useState, useEffect } from 'react';
import './RegisterDeliverable.css';

import axiosInstance from '../../axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

const RegisterDeliverable = ({ onClose }) => {
  const [email, setEmail] = useState('');
  const [initialCost, setInitialCost] = useState('');
  const [finalCost, setFinalCost] = useState('');
  const [balanceDue, setBalanceDue] = useState('');
  const [currentView, setCurrentView] = useState('register');
  const [searchDeliverable, setSearchDeliverable] = useState([]); // Initialize as an empty array
  const [selectedDeliverable, setSelectedDeliverable] = useState(null); // Stores the chosen deliverable
  const [registerForm, setRegisterForm] = useState({
    projectType: "Business Letter",
    customProjectType: "",
    // ...other register form fields if needed
  });
  

 
  const [searchEmail, setSearchEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [testResponse, setTestResponse] = useState(null);
  const [isClosed, setIsClosed] = useState(searchDeliverable?.closeOrder ? true : false);
  const defaultMessage = "This order will automatically close within 24 hours of the project deadline. To confirm acceptance of this deliverable and close the project, please click 'Approve.' If you'd like to request an additional revision due to factual inaccuracies, errors, or omissions, feel free to click 'Revise' within this time frame.";

  const [adminMessage, setAdminMessage] = useState('');

  



  const handleButtonClick = () => {
    setIsClosed((prevState) => !prevState); // Toggle between open/closed status
  };

  

  const handleInitialCostChange = (e) => {
    const value = e.target.value;
    setInitialCost(value);
    updateBalanceDue(value, finalCost);
  };
  
  const handleFinalCostChange = (e) => {
    const value = e.target.value;
  
    // Validate and format input
    if (/^\d*(\.\d{0,2})?$/.test(value)) {
      setFinalCost(value); // Save the formatted value
      const numericFinalCost = parseFloat(value || 0); // Convert to number
      updateBalanceDue(parseFloat(initialCost || 0), numericFinalCost); // Calculate balance
    }
  };
  
  
  // Function to render the final cost display
  const renderFinalCost = () => {
    if (balanceDue > 0) {
      return (
        <span >
          ${balanceDue.toFixed(2)}
        </span>
      );
    } else {
      return (
        <span style={{ color: 'purple', textAlign: 'left' }}>
          Paid in full
        </span>
      );
    }
  };
  
  const updateBalanceDue = (initial, final) => {
    const initialCostValue = parseFloat(initial) || 0;
    const finalCostValue = parseFloat(final) || 0;
    let balance = finalCostValue - initialCostValue;
  
    // Ensure balance has two decimal places
    balance = balance > 0 ? parseFloat(balance.toFixed(2)) : 0;
  
    setBalanceDue(balance);
  };
  
  
  const fetchSearchDeliverable = async (email) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`${API_URL}/api/deliverable`, {
        params: { email }
      });
  
      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        setSearchDeliverable(response.data); // multiple deliverables or a single one
        setSelectedDeliverable(null); // Reset selection
      } else {
        setSearchDeliverable([]); // Empty array if no results
      }
    } catch (error) {
      console.error('Error fetching Deliverable data:', error);
      setSearchDeliverable([]); // Empty array if an error occurs
    }
    setLoading(false);
  };
  

  const handleRegisterFormSubmit = async () => {
    const form = document.querySelector('#register-form');
    if (form.checkValidity()) {
      const formData = new FormData(form);
      formData.set(
        "adminMessage",
        adminMessage.trim() === "" ? defaultMessage : adminMessage.trim()
      );
      const data = Object.fromEntries(formData.entries());
   
  
      try {
        const response = await axiosInstance.post(`${API_URL}/api/deliverable`, data);
        alert('Submission successful:', response.data);
        onClose();
      } catch (error) {
        alert('Unable to submit:', error.response ? error.response.data : error.message);
      }
    } else {
      form.reportValidity();
    }
  };
  
  const handleSearchFormSubmit = async () => {
    if (searchEmail.trim()) {
      await fetchSearchDeliverable(searchEmail);
    } else {
      console.error('Email is required for search');
    }
  };

  const handleToggleClick = (view) => {
    if (currentView !== view) {
      setCurrentView(view);
    } else {
      if (view === 'register') {
        handleRegisterFormSubmit();
      } else if (view === 'search') {
        handleSearchFormSubmit();
      }
    }
  };

  useEffect(() => {
    if (currentView === 'search' && searchEmail) {
      fetchSearchDeliverable(searchEmail);
    }
  }, [currentView, searchEmail]);

   // Test endpoint function
   const testEndpoint = async () => {
    try {
      const response = await axiosInstance.post(`${API_URL}/api/test`, { message: 'Hello, server!' });
      setTestResponse(response.data.message);
    } catch (error) {
      console.error('Error testing endpoint:', error);
      setTestResponse('Error testing endpoint');
    }
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value.toLowerCase());
  };
  const handleRegisterProjectTypeChange = (e) => {
    const value = e.target.value;
    setRegisterForm((prev) => ({
      ...prev,
      projectType: value,
      customProjectType: value === "Other" ? "" : prev.customProjectType,
    }));
  };
  
  const handleCustomProjectTypeChange = (e) => {
    setRegisterForm((prev) => ({
      ...prev,
      customProjectType: e.target.value,
    }));
  };
  
  

  return (
    <div className="register-Deliverable">
      <div>
        <button className="close-button" onClick={onClose}>x</button>
        <div className="toggle-buttons">
          <button
            className={`toggle-button ${currentView === 'register' ? 'active' : ''}`}
            onClick={() => handleToggleClick('register')}
          >
            Register Submission
          </button>
          
          <button
            className={`toggle-button ${currentView === 'search' ? 'active' : ''}`}
            onClick={() => handleToggleClick('search')}
          >
            Search Deliverable
          </button>

        </div>
     
     
        <div className="popup-content">
        
         <div className="mini_container">
          
         {currentView === 'register' ? (
            <form id="register-form" onSubmit={handleRegisterProjectTypeChange}>
              <div className="mini_container">
              {registerForm.projectType === "Other" ? (
                <input
                  type="text"
                  name="projectType"
                  placeholder="Enter custom project type"
                  value={registerForm.customProjectType}
                  onChange={handleCustomProjectTypeChange}
                  maxLength={17}
                  required
                />
              ) : (
                <select
                  name="projectType"
                  value={registerForm.projectType}
                  onChange={handleRegisterProjectTypeChange}
                  required
                >
                  <option value="" disabled>Project Type</option>
                  <option value="Affidavit">Affidavit</option>
                  <option value="Business Letter">Business Letter</option>
                  <option value="Cease & Desist">Cease & Desist</option>
                  <option value="Equal Employment Opportunity Commission (EEOC)">Equal Employment Opportunity Commission (EEOC)</option>
                  <option value="Formal Grievance">Formal Grievance</option>
                  <option value="Formal Notice">Formal Notice</option>
                  <option value="Government Resume">Government Resume</option>
                  <option value="Grant Proposal">Grant Proposal</option>
                  <option value="Informal Resolution Attempt">Informal Resolution Attempt</option>
                  <option value="Initial Filing">Initial Filing (Administrative Proceeding)</option>
                  <option value="Letter of Inquiry">Letter of Inquiry</option>
                  <option value="Memorandum">Memorandum</option>
                  <option value="Modern Resume">Modern Resume</option>
                  <option value="Motion">Motion</option>
                  <option value="MSPB">Merit System Protection Board (MSPB)</option>
                  <option value="Notice of Non-Compliance">Notice of Non-Compliance</option>
                  <option value="Office of Special Counsel (OSC)">Office of Special Counsel (OSC)</option>
                  <option value="Office of Worker's Compensation (OWCP)">Office of Worker's Compensation (OWCP)</option>
                  <option value="Pleading">Pleading</option>
                  <option value="Professional Resume">Professional Resume</option>
                  <option value="Statement of Fact">Statement of Fact</option>
                  <option value="Other">Other</option>
                </select>
              )}
   <select name="preparer" required defaultValue="Ghostwriter">
                  <option value="" disabled>Prepared By</option>
                  <option value="Ghostwriter">Ghostwriter</option>
                  <option value="Independent Creator">Independent Creator</option>
                  <option value="3D Artist/Animator">3D Artist/Animator</option>
                  <option value="Client Advocate">Client Advocate</option>
                  <option value="Project Manager">Project Manager</option>
                  <option value="Support Desk">Support Desk</option>
                  <option value="Compliance & Security Team">Compliance & Security Team</option>
                </select>
                <input type="url" name="googleDriveLink" placeholder="Google Drive Link" required />
                <input
                  type="text"
                  name="email"
                  placeholder="Email"
                  required
                  value={email}
                  onChange={handleEmailChange}
                />
               

                </div>
                <div className="adminMessage">
                  <textarea
                    name="adminMessage"
                    value={adminMessage}
                    onChange={(e) => setAdminMessage(e.target.value)}
                    maxLength="300"
                    placeholder={defaultMessage}
                  />
                </div>
                <div className="last_box">
                  <div className="share3">
                    <div className="form-group">
                      <label htmlFor="completionDate" className="floating-label">Completed</label>
                      <input
                        type="date"
                        id="completionDate"
                        name="completionDate"
                        className="form-input"
                        min={new Date().toISOString().split("T")[0]}
                        value={new Date().toISOString().split("T")[0]} // Default to today's date
                        onFocus={(e) => e.target.parentElement.querySelector('.floating-label').classList.add('active')}
                        onBlur={(e) => {
                          const label = e.target.parentElement.querySelector('.floating-label');
                          if (!e.target.value) {
                            label.classList.remove('active');

                          }
                        }}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="deadline" className="floating-label">Deadline</label>
                      <input
                        type="date"
                        id="deadline"
                        name="deadline"
                        className="form-input"
                        min={new Date().toISOString().split("T")[0]}
                        onFocus={(e) => e.target.parentElement.querySelector('.floating-label').classList.add('active')}
                        onBlur={(e) => {
                          const label = e.target.parentElement.querySelector('.floating-label');
                          if (!e.target.value) {
                            label.classList.remove('active');
                            
                          }
                        }}
                        required
                      />
                    </div>
                  </div>
                  <div className="cost-container">
                    <input
                      type="text"
                      name="initialCost"
                      placeholder="Paid"
                      value={initialCost}
                      onChange={handleInitialCostChange}
                      required
                    />
                    <input
                      type="text"
                      name="finalCost"
                      placeholder="Total Cost"
                      value={finalCost}
                      onChange={handleFinalCostChange}
                      required
                    />
                  </div>
                </div>
                <div className="no_border">
                  <input
                    type="text"
                    name="balanceDue"
                    placeholder="Amount Due"
                    value={balanceDue > 0 ? `$${balanceDue}` : "0"}
                    readOnly
                    required
                    onChange={renderFinalCost}
                  />
                </div>
              </form>
            ) : (
            <div className="search-Deliverable">
              <input
              type="text"
              placeholder="Search by email"
              value={searchEmail}
              onChange={(e) => setSearchEmail(e.target.value.toLowerCase())}
              />
              {loading ? (
                <p>Loading...</p>
              ) : searchDeliverable.length > 0 ? (
              <div className="search-Deliverable_return">
               <select 
                  onChange={(e) => {
                    const selected = searchDeliverable.find(item => item._id === e.target.value);
                    setSelectedDeliverable(selected || null);
                  }}>

                  <option value="">Select a Deliverable</option>
                  {searchDeliverable.map((deliverable) => (
                    <option key={deliverable._id} value={deliverable._id}>
                      {deliverable.preparer} - {deliverable.completionDate}
                    </option>
                  ))}
               </select>
               {selectedDeliverable && (
                <>
                  <div className="share">
                    <input
                      type="date"
                      name="completionDate"
                      value={selectedDeliverable.completionDate || ''} 
                      readOnly
                      required
                    />
                    <select name="projectType" value={selectedDeliverable.projectType} disabled>
                      <option value="">{selectedDeliverable.projectType}</option>
                    </select>
                  </div>

                  <div className="adminMessag_return">
                    <p>{selectedDeliverable.adminMessage}</p>
                  </div>

                  <div className="last_box">
                    <button
                      onClick={handleButtonClick}
                      style={{
                        color: isClosed ? 'pink' : 'rgb(225, 84, 140)',
                        background: 'none',
                        border: 'none',
                        fontSize: '16px',
                        marginRight:'35px',
                        cursor: 'pointer',
                        textDecoration: 'none',
                      }}
                    >
                      {isClosed ? 'CLOSED' : 'OPEN'}
                    </button>

                    {isClosed && selectedDeliverable?.closeDate && (
                      <div className="date-container" style={{ color: 'red', marginRight:'35px' }}>
                        <span>{selectedDeliverable.closeDate || ''}</span>
                      </div>
                    )}

                    {!isClosed && selectedDeliverable?.openOrder && (
                      <div className="date-container" style={{ marginRight:'35px' }}>
                        <span>{selectedDeliverable.openOrder || ''}</span>
                      </div>
                    )}

                    <div>
                      <a href={selectedDeliverable.googleDriveLink} target="_blank" style={{ color: isClosed ? 'pink' : 'rgb(225, 84, 140)' }} rel="noopener noreferrer">
                        VIEW
                      </a>
                    </div>
                  </div>
                </>
              )}
                    
              </div>
              ) : (
              <div className="test-endpoint">
                <p>No data found</p>
                <button onClick={testEndpoint}>Test Endpoint</button>
                {testResponse && <p>Test Response: {testResponse}</p>
                }
              </div>
              )}
              </div>
            )}
              
          </div>
        </div>
      
    
      </div>
    </div>
  );}

export default RegisterDeliverable;
  
